import React, {
	useEffect,
	useState
} from 'react'

import {
	useDispatch,
	useSelector
} from 'react-redux'

import {
	closeAssignModal
} from '../programsSlice'

import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table'
import Spinner from 'react-bootstrap/Spinner'
import Modal from 'react-bootstrap/Modal'
import Alert from "react-bootstrap/Alert"
import Select from 'react-select'
import Form from 'react-bootstrap/Form'
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import  Toast  from 'react-bootstrap/Toast'
import { envAwarePost, dateToAPIStandard } from '../../../util/util'
import {dateToYMD} from '../../../util/datetime'
import { setShow } from '../../../state/percentMaxCalculator'
import {useClientsForAssignment} from '../hooks'
import {useMapClientsToOptions} from '../../../hooks/useMapClientsToOptions';
import  OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'


const mapTagsToOptions = tags => tags?.map(t => ({
	value: t.id,
	label: t.name,
	id: t.id
}))

/**
 * checks if an assigment will overlap with an existing so that we can warn a user
 * that they are about to create overlapping program assignemts.
 * program_id -- id of program being assigned
 * assignment_definition -- defines how the program is being assigned (eg by tag with exact match enabled)
 */
const assignmentHasOverlap = async (program_id,start_date,assignment_definition)=>{
	const {data:{has_overlap}} = await envAwarePost('api/programs/api/', {
		action: 'getOverlappingAssignments',
		assignment_definition,
		program_id,
		start_date
	})
	return has_overlap
}

const AssignModal = () => {

	const dispatch = useDispatch()
	const accountType = useSelector( state => state.users.current_user.account_type)
	const { program_id } = useSelector( state => state.programs.assignModal)
	const show = useSelector( state => state.programs.assignModal.show)
	const program = useSelector( state => (
		state.programs.programs.entities[program_id]
	))
	const {warning,status,clients} = useClientsForAssignment(program_id)
	const [tags, setTags] = useState([])
	const [assignSuccess, setAssignSuccess] = useState(false);
	const [assignLoading, setAssignLoading] = useState(false);

	const [specifyByTag, setSpecifyByTag] = useState(false)
	const [matchExactly, setMatchExactly] = useState(false)
	const [assignToAll, setAssignToAll] = useState(false)
	const [clientsToAssign, setClientsToAssign] = useState([])
	const [tagsToAssign, setTagsToAssign] = useState([])
	const [assignmentDate, setAssignmentDate] = useState(new Date())
	const [publish, setPublish] = useState(true);

	useEffect(() => {
		envAwarePost(
			'api/users/api/',
			{ action: 'getAllTags' }
		).then(res => {
			setTags(res.data)
		})
	}, [show])

	const assignProgram = async () => {

		const client_ids = clientsToAssign.map(client => client.id)
		const tag_ids = tagsToAssign.map(tag => tag.id)
		const start_date = dateToYMD(assignmentDate)
		setSpecifyByTag(false)
		setAssignmentDate(new Date())
		//dispatch(closeAssignModal())
		setClientsToAssign([])
		setTagsToAssign([])
		setAssignToAll(false)
		setMatchExactly(false)
		
		const assignment_definition = {
			assign_to_all: assignToAll && !specifyByTag ? 1 : 0,
			assign_by_tag: specifyByTag ? 1 : 0,
			match_exactly: matchExactly? 1 : 0,
		}
		setAssignLoading(true)
		const hasOverlap = await assignmentHasOverlap(program_id,start_date,assignment_definition)
		if(hasOverlap&&!window.confirm('You are about to assign a program with a start date that overlaps with existing assignemts. Assign program anyway?')){
			setAssignLoading(false)
			return
		}
		envAwarePost('api/programs/', {
			assign_to_all: assignToAll && !specifyByTag ? 1 : 0,
			assign_by_tag: specifyByTag ? 1 : 0,
			match_exactly: matchExactly? 1 : 0,
			action: 'assignProgram',
			client_ids,
			start_date,
			program_id,
			tag_ids,
			publish : publish ? "1" : "0"
		}).then( res => {
			setAssignLoading(false);
			if (res.success === '1') {
				setAssignSuccess(true);
			} else {
				alert(res.message)
			}
		})
	}
	function AlertDismissible() {
		return (
				<Toast onClose={() => setAssignSuccess(false)} show={assignSuccess} delay={2000} autohide style={{ margin:"auto", color: 'white', backgroundColor: '#4FD69C' }}>
					<Toast.Body><strong>Program successfully assigned</strong></Toast.Body>
				</Toast>
		);
	}

	const draftInfoText = () =>{
		return (
			<>
				Assign as draft
				<OverlayTrigger
					placement={"top"}
					overlay={
						<Tooltip>
							<p>All workouts, tasks, and nutrition in program will be assigned to client as drafts</p>
						</Tooltip>
					}
				>
					<i className="ml-1 fas fa-info-circle" />
				</OverlayTrigger>
			</>
		)
	}

	const clientsOptions = useMapClientsToOptions(clients)
	const tagsOptions = mapTagsToOptions(tags)
	if (accountType === 'client') return null
	return (
		<>
			<Modal centered show={show} onHide={() => { setAssignSuccess(false); dispatch(closeAssignModal()) }}>
				<Modal.Header closeButton>
					<div className="d-flex align-items-center">
						Assign to Clients
					</div>
				</Modal.Header>
				<Modal.Body>
					<div className="d-flex justify-content-between mb-2">
						<small>Search clients/tags or select all</small>
						<div className="d-flex align-items-center" style={{ fontSize: '14px' }}>
							<span className="mr-2">specify recipients by:</span>
							<label className="m-0 mr-2">
								<input
									name="create_specification"
									type="radio"
									onChange={() => setSpecifyByTag(false)}
									checked={!specifyByTag}
								/> Name
							</label>
							<label className="m-0">
								<input
									name="create_specification"
									type="radio"
									onChange={() => setSpecifyByTag(true)}
									checked={specifyByTag}
								/> Tag
							</label>
						</div>
					</div>
					<div className="d-flex">
						<div style={{ flex: '1 1 auto' }}>
							<Select
								isDisabled={assignToAll}
								value={specifyByTag ? tagsToAssign : clientsToAssign}
								isMulti={true}
								onChange={(value) => {
									if (specifyByTag) setTagsToAssign(value)
									else setClientsToAssign(value)
								}}
								noOptionsMessage={()=>(
									status === 'pending' ?
									`Loading ${specifyByTag?'tags':'clients'}...` :
									`No ${specifyByTag?'tags':'clients'}`
								)}
								options={specifyByTag ? tagsOptions : clientsOptions}
							/>
						</div>
						{!specifyByTag &&
							<Button
								onClick={() => setAssignToAll(!assignToAll)}
								variant={assignToAll ? 'success' : 'outline-success'}
								className="ml-1"
							>
								All
							</Button>
						}
					</div>
					{specifyByTag&&
						<Form.Check
							className="mt-1"
							checked={matchExactly}
							id="exact-tag-match-toggle-program"
							label="Only include clients that have ALL of the selected tags"
							onChange={e=>{setMatchExactly(e.target.checked)}}
						/>
					}
					{Boolean(warning)&&
						<small className="d-block text-muted">{warning}</small>
					}
					<div className="text-right my-2">
						<small>Select when</small>
						<DatePicker
							selected={assignmentDate}
							dateFormat="EEE, MMM d, yyyy"
							onChange={(date) => {
								setAssignmentDate(date)
							}}
							className="ml-1" />
							


                            <Form.Check
									className="mt-2"
                                    label={(draftInfoText())}
									value={publish}
                                    onChange={e => {
										setPublish(prev=>!prev)
                                    }}
                                    name="eventsAsDrafts"
                                    id="eventsAsDrafts"
                                    type="checkbox"
                            />
					</div>

						
					<div className="text-right">
						<Button
							disabled={
								(!specifyByTag && !clientsToAssign.length && !assignToAll) ||
								(specifyByTag && !tagsToAssign.length)
							}
							onClick={assignProgram}
							variant={
								(
									(!specifyByTag && (clientsToAssign.length || assignToAll)) ||
									(specifyByTag && tagsToAssign.length)
								)
									?
									"outline-primary" :
									"outline-secondary"
							}>
							{
								specifyByTag ?
									(
										tagsToAssign.length ?
											"Assign" : "Choose Tags"
									)
									:
									(
										clientsToAssign.length || assignToAll ?
											"Assign" : "Choose Clients"
									)
							}
						</Button>
					</div>
					<div className="d-flex justify-content-center">
						{assignLoading && <Spinner animation="border" role="status">
							<span className="sr-only ml-2">Loading...</span>
						</Spinner>}
					</div>

				</Modal.Body>
				{assignSuccess && <AlertDismissible />}
			</Modal>

		</>
	)
}
export default AssignModal